import React from 'react';
import { toAffiliated } from '../../../../../utils/linkAffiliater';
import { Form, Input, Select, Switch, InputNumber, Alert, Divider } from 'antd';

export const ExternalData = ({ externalDataStore, retailers }) => {
    const { url, setUrl, retailerId, setRetailerId, inStock, setInStock, originalPrice, setOriginalPrice, currentPrice, setCurrentPrice, isTouched, fetchFailed } = externalDataStore;

    const fixURL = () => {
        let inputValue = url;
        if (inputValue.trim().length > 0 && !inputValue.startsWith('http')) {
            inputValue = `https://${url}`;
        }
        const affiliatedUrl = toAffiliated(inputValue);
        if (affiliatedUrl) inputValue = affiliatedUrl;
        setUrl(inputValue, true);
    };

    return (
        <Form layout="vertical" size="small" style={{ width: '100%' }}>
            <Form.Item label="URL">
                <Input
                    placeholder="https://…"
                    value={url}
                    onChange={({ target }) => setUrl(target.value, true)}
                    onBlur={fixURL}
                />
            </Form.Item>

            <Form.Item label="Retailer">
                <Select
                    value={retailerId || undefined}
                    placeholder="Choose retailer…"
                    onChange={(val) => setRetailerId(val, true)}
                    options={retailers
                        .filter(r => r.name.toLowerCase() !== 'target')
                        .map(r => ({ value: r.id, label: r.name }))}
                    style={{ width: '100%' }}
                />
            </Form.Item>

            <Divider style={{ margin: '4px 0 8px' }} />

            <Form.Item label="In stock" valuePropName="checked">
                <Switch checked={!!inStock} onChange={setInStock} />
            </Form.Item>

            <Form.Item label="Original price">
                <InputNumber
                    min={0}
                    step={0.01}
                    placeholder="0.00"
                    value={originalPrice || undefined}
                    onChange={(val) => setOriginalPrice(val)}
                    prefix="$"
                    style={{ width: '100%' }}
                />
            </Form.Item>

            <Form.Item label="Current price">
                <InputNumber
                    min={0}
                    step={0.01}
                    placeholder="0.00"
                    value={currentPrice || undefined}
                    onChange={(val) => setCurrentPrice(val)}
                    prefix="$"
                    style={{ width: '100%' }}
                />
            </Form.Item>

            {(isTouched && !fetchFailed) && (
                <Alert type="warning" showIcon message="Haven't scraped yet" style={{ marginTop: 4 }} />
            )}

            {fetchFailed && (
                <Alert type="error" showIcon message="Scheduler error — contact dev team" style={{ marginTop: 4 }} />
            )}
        </Form>
    );
};
